import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { PendingChangesDialogComponent } from '@shared/components/dialog/pending-changes/pending-changes-dialog.component';
import { Observable, Subject, tap } from 'rxjs';

@Injectable()
export class DirtyStateService {
  private _isDirty: WritableSignal<boolean> = signal<boolean>(false);

  public isDirty: Signal<boolean> = this._isDirty.asReadonly();

  private _clear$: Subject<void> = new Subject<void>();

  public clear$: Observable<void> = this._clear$.asObservable();

  public markDirty (): void {
    this._isDirty.set(true);
  }

  public clear (): void {
    this._isDirty.set(false);
    this._clear$.next();
  }
}
export const pendingChangedGuard: CanDeactivateFn<unknown> = () => {
  const dirtyStateService: DirtyStateService = inject(DirtyStateService);
  const dialog: MatDialog = inject(MatDialog);


  if (!dirtyStateService.isDirty()) return true;

  return dialog.open(PendingChangesDialogComponent).afterClosed()
    .pipe(
      tap((isConfirmed: boolean) => {
        if (isConfirmed)
          dirtyStateService.clear();
      })
    );
};

